import React from 'react';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import {
  PreviewHeader, PreviewPage, PreviewPanel, PreviewTable,
} from '../../../../components/access-denied/preview/PreviewParts';

/** Prévia falsa da auditoria para a tela de bloqueio (dados de exemplo fixos). */
const AuditLockedPreview = () => (
  <PreviewPage>
    <PreviewHeader icon={<FactCheckOutlinedIcon />} title="Auditoria" subtitle="Quem abriu, alterou ou baixou cada cadastro" />
    <PreviewPanel>
      <PreviewTable
        columns={['Data', 'Usuário', 'Ação', 'IP']}
        rows={[
          ['01/01 09:00', 'Usuário de exemplo', 'Abriu o prontuário', '000.000.0.0'],
          ['01/01 09:20', 'Usuário de exemplo', 'Alterou o cadastro', '000.000.0.0'],
          ['01/01 10:05', 'Usuário de exemplo', 'Baixou um anexo', '000.000.0.0'],
          ['01/01 11:40', 'Usuário de exemplo', 'Abriu o prontuário', '000.000.0.0'],
          ['01/01 14:15', 'Usuário de exemplo', 'Gerou um documento', '000.000.0.0'],
        ]}
      />
    </PreviewPanel>
  </PreviewPage>
);

export default AuditLockedPreview;
